export default {
    city: [
        {
            name: "郑州",
            value: 599,
        },
        {
            name: "开封市",
            value: 142,
        },
        {
            name: "洛阳市",
            value: 44,
        },
        {
            name: "平顶山市",
            value: 999,
        },
        {
            name: "安阳市",
            value: 599,
        },
        {
            name: "焦作市",
            value: 142,
        },
        {
            name: "新乡市",
            value: 44,
        },
        {
            name: "鹤壁市",
            value: 999,
        },
        {
            name: "濮阳市",
            value: 142,
        },
        {
            name: "许昌市",
            value: 44,
        },
        {
            name: "漯河市",
            value: 999,
        },
        {
            name: "三门峡市",
            value: 999,
        },
        {
            name: "南阳市",
            value: 99,
        },
        {
            name: "商丘市",
            value: 99,
        },
        {
            name: "驻马店市",
            value: 99,
        },
        {
            name: "信阳市",
            value: 123,
        },
        {
            name: "周口市",
            value: 99,
        },
        {
            name: "济源市",
            value: 999,
        }
    ],
    geoCoordMap:{
        '郑州':[113.43,34.46],
    }
}